import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ContactSession {
  id: string;
  status: string;
  demand_type: string | null;
  created_at: string;
  resolution_notes: string | null;
  resolution_type: string | null;
}

export function useContactSessions(contactId: string | null) {
  const queryClient = useQueryClient();

  // Realtime: atualizar quando sessões do contato mudam
  useEffect(() => {
    if (!contactId) return;

    const channel = supabase
      .channel(`contact-sessions-${contactId}`)
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'support_sessions', filter: `contact_id=eq.${contactId}` },
        () => {
          queryClient.invalidateQueries({ queryKey: ['contact-sessions', contactId] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [contactId, queryClient]);

  return useQuery({
    queryKey: ['contact-sessions', contactId],
    queryFn: async (): Promise<ContactSession[]> => {
      if (!contactId) return [];
      
      const { data, error } = await supabase
        .from('support_sessions')
        .select('id, status, demand_type, created_at, resolution_notes, resolution_type')
        .eq('contact_id', contactId)
        .order('created_at', { ascending: true });
      
      if (error) throw error;
      return data || [];
    },
    enabled: !!contactId,
  });
}
